import * as React from 'react';

import { PageAlert} from '@cvent/carina/components/Alert';

const styles = require('../CheckOutPage.module.scss');

const SuccessAlert = () => {
    const [shouldShowAlert, setShouldShowAlert] = React.useState<boolean>(true);
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            setShouldShowAlert(false);
        }, 5000);
        return () => {
            clearTimeout(timeout);
        };
    }, []);

    if (!shouldShowAlert) {
        return null;
    }

    return (
        <div className={styles.alertWrapper}>
            <PageAlert
                appearance="success"
                content= 'Your message was sent'
                dismissible={true}
                id="0"
                onDismiss={() => setShouldShowAlert(false)}
            />
        </div>
    );
};

export default SuccessAlert;
